import React, { useState, useEffect } from 'react'
import qs from 'qs'
import server from 'server/serverController2'
import { removeItem } from 'utils/utils'

import Presenter from 'components/presenters/signup/UserCategoryScene'
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter'

export default function UserCategoryScene({
  initCategories,
  currSceneNum,
  totalSceneNum,
  onComplete,
}) {
  const [selectedCategory, setSelectedCategory] = useState([])
  const [categories, setCategories] = useState([])
  const [validFooterBtn, setValidFooterBtn] = useState(false)
  const displayCategoryNo = [{ no: 2 }, { no: 5 }, { no: 8 }, { no: 1 }, { no: 41 }, { no: 40 }] //order matters (left to right / top to bottom)
  useEffect(() => {
    if (Array.isArray(initCategories) && initCategories?.length > 0) {
      setSelectedCategory(initCategories)
    }
  }, [initCategories])

  useEffect(() => {
    let queryString = qs.stringify({ parent_no: 0, limit: 100 })
    server.getRequestData(`categories?${queryString}`, (res) => {
      try {
        if (res.success !== 1) {
          return
        }
        let jsonData = res.data
        const dataList = jsonData['categories']
        const displayCateogires = []
        for (let i = 0; i < displayCategoryNo.length; ++i) {
          for (let j = 0; j < dataList.length; ++j) {
            if (parseInt(displayCategoryNo[i]['no']) === parseInt(dataList[j]['no'])) {
              displayCateogires.push(dataList[j])
            }
          }
        }
        setCategories(displayCateogires)
        return
      } catch (err) {
        console.log(err)
      }
    })
  }, [])

  useEffect(() => {
    if (selectedCategory.length > 0 && selectedCategory.length < 3) {
      setValidFooterBtn(true)
    } else {
      setValidFooterBtn(false)
    }
  }, [selectedCategory])

  const handleToggle = (targetNo) => {
    let newSelectedList = selectedCategory.slice()
    for (let i = 0; i < categories.length; ++i) {
      if (parseInt(categories[i]['no']) === parseInt(targetNo)) {
        const targetCategory = categories[i]
        let existedIndex = null
        for (let j = 0; j < selectedCategory.length; ++j) {
          if (parseInt(selectedCategory[j]['no']) === parseInt(targetNo)) {
            existedIndex = j
            break
          }
        }

        if (existedIndex !== null) {
          newSelectedList = removeItem(newSelectedList, existedIndex)
        } else if (newSelectedList.length < 2) {
          newSelectedList.push(targetCategory)
        }
      }
    }

    setSelectedCategory(newSelectedList)
  }
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Presenter
        categories={categories}
        selectedCategory={selectedCategory}
        onToggle={handleToggle}
      />
      <ScenePaginationFooter
        currSceneNum={currSceneNum}
        totalSceneNum={totalSceneNum}
        valid={validFooterBtn}
        onComplete={() => {
          onComplete({ categories: selectedCategory })
        }}
      />
    </div>
  )
}
